import Alert from "@material-ui/lab/Alert";
import styled, { css } from "styled-components";

export const InputBox = styled.div`
	position: relative;
`;

export const AlertBox = styled(Alert)`
	position: absolute;
	left: 0;
	bottom: -13px;
	padding-left: 0 !important;

	${(props) =>
		props.$select &&
		css`
			bottom: -32px;
		`}

	&.MuiAlert-standardError {
		background-color: transparent;
	}

	.MuiAlert-message {
		padding-top: 0;
		padding-bottom: 0;
		font-size: 12px;
	}
	.MuiAlert-icon {
		padding-top: 0;
		padding-bottom: 0;
		width: 17px;
		height: 17px;

		.MuiSvgIcon-root {
			width: 17px;
			height: 17px;
		}
	}
`;
